import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from 'src/app/token.service';
import {MainService} from './main.service'
import { MakingDataService } from './making-data.service';
@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private mds:MakingDataService,private MainService:MainService,private http:HttpClient, private token:TokenService) { }
  httpUrl = this.MainService.httpUrl
  async updateRole(obj :any) {
    const res = await this.http.put<any>(this.httpUrl + '/md/role/updaterole',obj ).toPromise().then(res => {
      return res;
    });
    return res;
  }
  // async deleteRole(obj :any) {
  //   const resp = await this.http.delete<any>(this.httpUrl +'/md/role/inactiverole'+JSON.stringify(obj)).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  async deleteRole(obj :any) {
    const res = await this.http.put<any>(this.httpUrl + '/md/role/inactiverole',obj ).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async createMdRole(obj :any) {
    const res = await this.http.post<any>(this.httpUrl + '/md/role/createrole', obj ).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async getMdResource(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/resource/getcurrentresource' + obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getMdModules(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/resource/getmodules' + obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async AllModules(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/resource/getAccountModules' + obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  // async getCurrentMdrole(obj :any) {
  //   const resp = await this.http.get<any>(this.httpUrl + '/md/role/getcurrentroles' + JSON.stringify({}),  { headers: new HttpHeaders().append('data',await this.mds.dataE(obj)) }).toPromise().then(async res => {
  //     return await this.mds.dataD(res);
  //   });
  //   return resp;
  // }
  async getCurrentMdrole(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/role/getcurrentroles' + obj).toPromise().then(async res => {
      return res
    });
    return resp;
  }
  async getcurrentroleswithresources(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/role/getroleswithresources' + obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
}
